<template>
  <button
    class="sdv-button sdv-embed-component"
    :class="classes"
    @click="$emit('click')"
  >
    <span class="sdv-focus-helper" />
    <span class="sdv-button__content">
      <SdvIcon
        v-if="svg"
        :class="leftIconClasses"
        :svg="svg"
      />
      <slot>
        {{ label }}
      </slot>
    </span>
  </button>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue-demi'
import SdvIcon from '../SdvIcon/SdvIcon.vue'

export default defineComponent({
  name: 'SdvBtn',
  components: {
    SdvIcon
  },
  props: {
    svg: {
      type: String,
      required: false,
      default: undefined
    },
    label: {
      type: String,
      required: false,
      default: undefined
    },
    color: {
      type: String,
      required: false,
      default: undefined
    },
    textColor: {
      type: String,
      required: false,
      default: undefined
    },
    outline: {
      type: Boolean,
      required: false,
      default: false
    },
    round: {
      type: Boolean,
      required: false,
      default: false
    },
    rounded: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: {
    click: () => true
  },
  setup (props, context) {
    const classPrefix = 'sdv-button'
    const classes = computed(() => {
      const classes = []
      if (props.round) { classes.push(classPrefix + '--round') }
      if (props.rounded) { classes.push(classPrefix + '--rounded') }
      if (props.outline) { classes.push(classPrefix + '--outline') }
      return classes
    })
    const leftIconClasses = computed(() => {
      const classes = []
      if (props.label != null || context.slots.default != null) {
        classes.push('sdv-button__icon--on-left')
      }
      return classes
    })
    return {
      leftIconClasses,
      classes
    }
  }
})
</script>

<style lang="scss" src="./SdvBtn.scss" />
